module.exports = __webpack_public_path__ + "static/media/order_icon31.94316a24.png";